import React from 'react';
import styles from './index.module.less';
import Link from 'next/link';

export default function ThinkView({ data }: { data: any }) {
  const title = data?.contentInfo?.['section-think']?.title || '';
  const bodyText = data?.contentInfo?.['section-think']?.bodyText || [];
  const links = data?.contentInfo?.['section-think']?.links || [];

  // 渲染描述文本，将 links 中的 title 替换为可点击的链接
  const renderDesc = (text: string) => {
    if (!links.length) return text;

    const parts: React.ReactNode[] = [];
    let remainingText = text;

    links.forEach((linkItem: { title: string; link: string }, index: number) => {
      const linkIndex = remainingText.indexOf(linkItem.title);
      if (linkIndex !== -1) {
        // 添加链接前的文本
        if (linkIndex > 0) {
          parts.push(remainingText.slice(0, linkIndex));
        }
        // 添加链接
        parts.push(
          <Link key={index} href={linkItem.link} target="_blank" rel="noopener noreferrer" className={styles.descLink}>
            {linkItem.title}
          </Link>,
        );
        remainingText = remainingText.slice(linkIndex + linkItem.title.length);
      }
    });

    // 添加剩余文本
    if (remainingText) {
      parts.push(remainingText);
    }

    return parts.length > 0 ? parts : text;
  };

  return (
    <div className={styles.container}>
      {/* ThinkView */}
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.descWrapper}>
        {bodyText.map((text: string, pIndex: number) => (
          <p className={styles.desc} key={pIndex}>
            {renderDesc(text)}
          </p>
        ))}
      </div>
    </div>
  );
}
